<template>
  <el-menu
    :default-active="element.active"
    :router="element.router"
    class="el-menu-vertical-demo"
    active-text-color="#add8e6">
    <el-menu-item v-for="(item, key) in navList" :key="key" :index="item.path">
      <span slot="title">{{item.navItem}}</span>
    </el-menu-item>
  </el-menu>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        navList: [
          { path: '/', navItem: '首页' },
          { path: '/course_list', navItem: '课程管理' },
          { path: '/activity_list', navItem: '优惠管理' },
          { path: '/school_list', navItem: '学校管理' },
          { path: '/coach_list/1', navItem: '教练管理' },
          { path: '/student_list/1', navItem: '学员管理' },
          { path: '/order_list/1', navItem: '订单管理' },
          { path: '/cert_list/1', navItem: '证书管理' },
          { path: '/stock_list/1', navItem: '库存记录' }
        ],
        element: {
          router: true,
          active: ''
        }
      };
    },
    mounted() {
      this.element.active = this.$route.matched[1].path;
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .el-menu-vertical-demo
    height: 100%;
</style>